export default __webpack_public_path__ + "static/media/imageProfile.7fd43c8e.png";